<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a @click="backButton">
        <li>Liabilities</li>
      </a>
      <a @click="depositeDashbord">
        <li>&nbsp;>&nbsp;Credit Card Loan</li>
      </a>
      <li>&nbsp;>&nbsp;Credit Card Loan</li>
    </ul>
    <h4 class="welcome-text">Credit Card Loan</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
          <h4>Enter Details</h4>
          <v-row>
            <v-col
              xs="12"
              md="6"
              class="member_relation_box col"
              v-for="formAttr in formAttributes"
              :key="formAttr.id"
            >
              <label
                class="member-label"
                v-if="formAttr['name'] == 'current_value'"
                >Current Value as on
                {{ currentDate | moment("DD MMM, YY") }}</label
              >
              <label
                class="member-label"
                v-else-if="formAttr['name'] == 'market_price'"
                >Market Price as on
                {{ currentDate | moment("DD MMM, YY") }}</label
              >
              <label class="member-label" v-else-if="formAttr['name'] == 'nav'"
                >Nav as on {{ currentDate | moment("DD MMM, YY") }}</label
              >
              <label class="member-label" v-else
                >{{ formAttr["label"] }}
              </label>
              <div
                v-if="
                  formAttr['type'] == 'select' && formAttr['name'] != 'nominee'
                "
              >
                <v-select
                  ref="form_attrs"
                  :name="formAttr['name']"
                  :v-model="formAttr['name']"
                  :items="
                    formAttr['name'] == 'bank_name'
                      ? bank
                      : formAttr['name'] == 'account_owner'
                      ? account_owner
                      : formAttr['name'] == 'liability_type'
                      ? liability_type
                      : formAttr['name'] == 'insurance'
                      ? insurance
                      : formAttr['name'] == 'emi'
                      ? emi
                      : []
                  "
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                ></v-select>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'select' && formAttr['name'] == 'nominee'
                "
              >
                <v-combobox
                  :ref="formAttr['name']"
                  :name="formAttr['name']"
                  v-model="addMoreField"
                  :items="nominee"
                  item-value="id"
                  item-text="name"
                  :rules="
                    formAttr['is_required'] == true
                      ? [(v) => !!v || 'Field is required']
                      : []
                  "
                  @change="setMasterData(formAttr['name'], $event)"
                  :placeholder="formAttr['place_holder']"
                  multiple
                  small-chips
                  solo
                  v-on:input="limiter"
                  deletable-chips
                ></v-combobox>
              </div>
              <div
                v-else-if="
                  formAttr['type'] == 'input' &&
                  formAttr['name'] == 'monthly_rate_of_interest'
                "
                :class="formAttr['icon'] == 'rupyee.png' ? 'rupee-icon' : ''"
              >
                <v-text-field
                  :name="formAttr['name']"
                  :maxlength="length_limit"
                  ref="form_attrs"
                  :rules="[
                    formAttr['is_required'] == true
                      ? (v) => !!v || 'Field is required'
                      : [],
                    formAttr['is_numeric'] == true
                      ? (v) => /^\d*\.?\d*$/.test(v) || 'Field must be numeric'
                      : [],
                  ]"
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="calculateAmounts(formAttr['name'], $event)"
                  :value="
                    formAttr['name'] == 'monthly_rate_of_interest'
                      ? monthly_rate_of_interest
                      : ''
                  "
                ></v-text-field>
              </div>
              <div
                v-else-if="formAttr['type'] == 'input'"
                :class="formAttr['icon'] == 'rupyee.png' ? 'rupee-icon' : ''"
              >
                <v-text-field
                  :name="formAttr['name']"
                  :maxlength="length_limit"
                  ref="form_attrs"
                  :rules="[
                    formAttr['is_required'] == true
                      ? (v) => !!v || 'Field is required'
                      : [],
                    formAttr['is_numeric'] == true
                      ? (v) => /^\d*\.?\d*$/.test(v) || 'Field must be numeric'
                      : [],
                  ]"
                  :v-model="formAttr['name']"
                  :placeholder="formAttr['place_holder']"
                  @input="calculateAmounts(formAttr['name'], $event)"
                  :readonly="
                    formAttr['name'] == 'nav' ||
                    formAttr['name'] == 'current_value' ||
                    formAttr['name'] == 'symbol' ||
                    formAttr['name'] == 'market_price' ||
                    formAttr['name'] == 'tenure_left' ||
                    formAttr['name'] == 'liability_type'
                  "
                  :value="
                    formAttr['name'] == 'symbol'
                      ? symbol
                      : formAttr['name'] == 'monthly_rate_of_interest'
                      ? monthly_rate_of_interest
                      : formAttr['name'] == 'market_price'
                      ? market_price
                      : formAttr['name'] == 'current_value'
                      ? current_value
                      : formAttr['name'] == 'no_of_emis'
                      ? number_of_emi
                      : ''
                  "
                ></v-text-field>
                <a
                  @click="appendEMIFields"
                  class="add-newbox"
                  v-if="formAttr['name'] == 'no_of_emis'"
                  >Add EMI Details</a
                >
              </div>
              <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                <Datepicker
                  :name="formAttr['name']"
                  ref="form_attrs"
                  :v-model="formAttr['name']"
                  :disabledDates="
                    formAttr['name'] == 'expiry_date' ? disabledDates : ''
                  "
                  format="dd MMM, yyyy"
                  :placeholder="formAttr['place_holder']"
                  @selected="
                    calculateAmountsWithDates($event, formAttr['name'])
                  "
                ></Datepicker>
              </div>
            </v-col>
          </v-row>

          <v-row
            v-if="emi_details.length != 0"
            v-for="emiList in emi_details"
            :key="emiList.id"
          >
            <v-col
              xs="12"
              md="12"
              class="member_relation_box col esop-addform-box"
            >
              <v-card class="boxs">
                <span>EMI {{ emiList.grantnumber }}</span>
                <div class="close-icon">
                  <v-img
                    max-height="20"
                    max-width="20"
                    src="../../../assets/images/delete.png"
                    @click="removeGrantDetail(emiList.grantnumber)"
                  ></v-img>
                </div>
                <v-row class="esop-addform-box-detail">
                  <v-col xs="6" md="6">
                    <label class="member-label">Loan Amount</label>
                    <div class="rupee-icon">
                      <v-text-field
                        readonly
                        :value="emiList.loan_amount"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col xs="6" md="6">
                    <label class="member-label">Current Outstanding</label>
                    <div class="rupee-icon">
                      <v-text-field
                        readonly
                        :value="emiList.current_outstanding"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col xs="6" md="6">
                    <label class="member-label">EMI Amount</label>
                    <div class="rupee-icon">
                      <v-text-field
                        readonly
                        :value="emiList.emi_amount"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col xs="6" md="6">
                    <label class="member-label">EMI Start Date</label>
                    <div class="dob-box">
                      <Datepicker
                        class="no-click"
                        format="dd MMM, yyyy"
                        :value="emiList.start_date"
                      ></Datepicker>
                    </div>
                  </v-col>
                  <v-col xs="6" md="6">
                    <label class="member-label">EMI End Date</label>
                    <div class="dob-box">
                      <Datepicker
                        class="no-click"
                        format="dd MMM, yyyy"
                        :value="emiList.end_date"
                      ></Datepicker>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <span
            v-bind:class="{ 'error-messagebox-login': isAddClassServerError }"
            id="server_side_error"
            >{{ serverError }}</span
          >

          <v-row class="buttonbox">
            <v-btn class="blue-border-btn" @click="depositeAccounts">
              Cancel
            </v-btn>
           <v-btn
                class="blue-btn"
                @click="submit"
                :disabled="!isFormValid"
                
               
              >
                Save
              </v-btn>
          </v-row>

          <v-form ref="grantForm" lazy-validation>
            <v-row justify="center">
              <v-dialog
                class="login-form-box esop-modal-formbox"
                v-model="dialog"
                persistent
                max-width="730px"
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5"></span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="6" class="member_relation_box col">
                          <label>EMI Start Date</label>
                          <div class="dob-box">
                            <Datepicker
                              name="start-date"
                              ref="start-date"
                              v-model="startDate"
                              format="dd MMM, yyyy"
                              placeholder="Start date"
                            ></Datepicker>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="member_relation_box col">
                          <label>EMI End Date</label>
                          <div class="dob-box">
                            <Datepicker
                              name="End-date"
                              ref="End-date"
                              v-model="endDate"
                              format="dd MMM, yyyy"
                              placeholder="End date"
                            ></Datepicker>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="member_relation_box col">
                          <label>Loan Amount</label>
                          <div class="rupee-icon">
                            <v-text-field
                              v-model="loanAmount"
                              :maxlength="emi_length"
                              placeholder="Loan Amount"
                              :rules="[
                                (v) =>
                                  /^\d*\.?\d*$/.test(v) ||
                                  'Field must be numeric',
                                (v) => !!v || 'Field is required',
                              ]"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="member_relation_box col">
                          <label>Current Outstanding</label>
                          <div class="rupee-icon">
                            <v-text-field
                              v-model="currentOutstanding"
                              :maxlength="emi_length"
                              placeholder="Current Outstanding"
                              :rules="[
                                (v) =>
                                  /^\d*\.?\d*$/.test(v) ||
                                  'Field must be numeric',
                                (v) => !!v || 'Field is required',
                              ]"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6" class="member_relation_box col">
                          <label>EMI Amount</label>
                          <div class="rupee-icon">
                            <v-text-field
                              v-model="emiAmount"
                              :maxlength="emi_length"
                              placeholder="EMI Amount"
                              :rules="[
                                (v) =>
                                  /^\d*\.?\d*$/.test(v) ||
                                  'Field must be numeric',
                                (v) => !!v || 'Field is required',
                              ]"
                            ></v-text-field>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="addGrants"
                      >Add</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="closeGrantDialog"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-form>
        </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  sameAs,
  isAlphanumeric,
  alpha,
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";

import {
  GET_CREDIT_CARD_FORM,
  SAVE_LIABILITY_FORM_DETAIL,
  GET_LIABILITY_FORM_DETAIL,
} from "../../../store/actions.type";
import { isEmpty } from "lodash";
export default {
  components: {
    Datepicker,
  },
  mixins: [validationMixin],
  validations: {},
  data: () => ({
    valid: true,
    submitted: false,
    activePicker: null,
    menu: false,
    isFormValid: false,
    disabledDates: {
      to: new Date(),
    },
    serverError: "",
    isAddClassServerError: false,
    formAttributes: "",
    formAttr: "",
    emi_length: 15,
    familyMember: [],
    nominee: [],
    other_nominee: [],
    curr_balance_date: "",
    account_type: "",
    bank_name: "",
    account_owne: "",
    addMoreField: [],
    nomineeMembers: [],
    form_id: "",
    account_owner: [],
    nominee: [],
    currentDate: new Date().setDate(new Date().getDate()),
    scheme_name: [],
    current_value: "",
    exchange: [],
    symbol: "",
    monthly_rate_of_interest: "",
    market_price: "",
    security_list: [],
    bank: [],
    liability_type: [],
    insurance: [],
    start_date: "",
    expiry_date: "",
    emi_date: "",
    tenure_days: "",
    tenure_left: "",
    emi_day: [],
    length_limit: 20,
    emi: [],
    other_form_field: [],
    insurance_value: false,
    number_of_emi: 0,
    emi_end_date: "",
    emi_start_date: "",
    current_outstanding: "",
    loan_amount: "",
    emi_amount: "",

    loanAmount: "",
    currentOutstanding: "",
    emiAmount: "",
    startDate: "",
    endDate: "",

    dialog: false,
    emi_details: [],
    grantObj: {},
  }),
  created() {
    Fire.$on("loadData", () => {
      this.getLaibilityFormData();
    });
  },
  mounted() {
    if (isEmpty(this.$store.getters.getCreditCardForm)) {
      this.getLaibilityFormData();
    } else {
      this.form_id = this.$store.getters.getCreditCardForm.data.form_id;
      this.formAttributes =
        this.$store.getters.getCreditCardForm.data.form_attributes.fields;
      let masterDataArr =
        this.$store.getters.getCreditCardForm.data.master_data;
      console.log({ masterDataArr });

      masterDataArr.forEach((element) => {
        if (element.Bank) {
          element.Bank.forEach((bankName) => {
            this.bank.push({ id: bankName.id, name: bankName.name });
          });
        }
        if (element.FamilyMember) {
          element.FamilyMember.forEach((dataFamily) => {
            this.nominee.push(dataFamily.name);
            if (dataFamily.id == 0) {
              this.account_owner.push({ id: "0", name: dataFamily.name });
            } else {
              this.account_owner.push({
                id: dataFamily.id,
                name: dataFamily.name,
              });
            }
          });
        }
        if (element.InsuranceType) {
          element.InsuranceType.forEach((insurance) => {
            if (insurance.id == 0) {
              this.insurance.push({ id: "0", name: insurance.name });
            } else {
              this.insurance.push({ id: insurance.id, name: insurance.name });
            }
          });
        }
        if (element.EMIDate) {
          element.EMIDate.forEach((emidate) => {
            if (emidate.id == 0) {
              this.emi_day.push({ id: "0", name: emidate.name });
            } else {
              this.emi_day.push({ id: emidate.id, name: emidate.name });
            }
          });
        }
        if (element.EMIType) {
          element.EMIType.forEach((emiType) => {
            this.emi.push({
              id: emiType.id,
              name: emiType.name,
            });
          });
        }
      });
    }
  },
  methods: {
    limiter(e) {},
    validate() {
      this.$refs.form.validate();
    },
    backButton() {
      this.$router
        .push({
          name: "liabilities-subcategory",
        })
        .catch(() => {});
    },
    depositeAccounts() {
      this.$router
        .push({
          name: "liabilities-dashboard",
        })
        .catch(() => {});
    },
    appendField() {},
    removeField(val) {
      if (val == 0) {
        this.other_form_field.splice(val);
      } else {
        this.other_form_field.splice(val, val);
      }
    },
    setData(key) {
      console.log(key);
    },
    addGrants() {
      let getFormData = document.querySelector("#saving_account");
      if (this.endDate && this.startDate) {
        if (moment(this.startDate) > moment(this.endDate)) {
          swal
            .fire({
              title: "End Date should be after Start date.",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
            })
            .then(() => {});
          return;
        }
      }

      if (this.$refs.grantForm.validate()) {
        if (getFormData.no_of_emis.value > this.emi_details.length) {
          this.grantObj = {
            grantnumber: parseInt(this.emi_details.length + 1),
            loan_amount: this.loanAmount ? this.loanAmount : 0,
            current_outstanding: this.currentOutstanding
              ? this.currentOutstanding
              : 0,
            emi_amount: this.emiAmount ? this.emiAmount : 0,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
          };
          this.emi_details.push(this.grantObj);

          this.closeGrantDialog();
        }
      }
    },
    closeGrantDialog() {
      this.grantObj = {};
      this.loanAmount = "";
      this.currentOutstanding = "";
      this.emiAmount = "";
      this.startDate = "";
      this.endDate = "";
      this.dialog = false;
    },
    removeGrantDetail(grantnumber) {
      let i = 0;
      this.emi_details = this.emi_details.filter(
        (item) => item.grantnumber != grantnumber
      );
      this.emi_details.forEach((data) => {
        data.grantnumber = ++i;
      });
    },
    appendEMIFields() {
      let getFormData = document.querySelector("#saving_account");
      if (
        getFormData.no_of_emis.value &&
        getFormData.no_of_emis.value.match(/^[0-9]+$/) != null
      ) {
        if (getFormData.no_of_emis.value == this.emi_details.length) {
          swal
            .fire({
              title: "",
              text:
                "You have already added " +
                getFormData.no_of_emis.value +
                " EMI's.",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#051d42",
              confirmButtonText: "OK",
            })
            .then((result) => {
              if (result.isConfirmed) {
                return;
              }
            });
        } else {
          this.dialog = true;
        }
      } else {
        swal
          .fire({
            title: "",
            text: "Please enter valid no. of EMI's.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#051d42",
            confirmButtonText: "OK",
          })
          .then((result) => {
            if (result.isConfirmed) {
              return;
            }
          });
      }
    },
    submit(e) {
      this.checkFormData = [];
      let getFormData = document.querySelector("#saving_account");
      var formData = new FormData(getFormData);
      for (const [key, value] of formData.entries()) {
        if (value) {
          this.checkFormData.push(value);
        }
      }
      if (this.checkFormData.length > 1) {
        this.submitted = true;
        let jsonObject = [];
        let nominee = [];
        let i = 0;
        for (const [key, value] of formData.entries()) {
          if (key == "scheme_type") {
            if (!isNaN(value) == true) {
              jsonObject.push({ key: key, values: value });
            } else {
              continue;
            }
          } else if (key == "scheme_name") {
            if (!isNaN(value) == true) {
              jsonObject.push({ key: key, values: value });
            } else {
              continue;
            }
          } else if (
            key == "account_owner" ||
            key == "bank_name" ||
            key == "insurance" ||
            key == "emi"
          ) {
            jsonObject.push({
              key: key,
              values: value != "" ? parseInt(value) : value,
            });
          } else {
            if (key != "nominee") {
              jsonObject.push({ key: key, values: value });
            }
          }
          i++;
        }

        let nomineeArr = {
          key: "nominee",
          values: nominee,
        };
        jsonObject.push(nomineeArr);

        let collected_data = {
          collected_data: jsonObject,
          emi_details: this.emi_details,
        };
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
        this.$store
          .dispatch(SAVE_LIABILITY_FORM_DETAIL, {
            data: {
              aws_cognito_id: cognito_idp,
              form_id: this.form_id,
              account_owner: getFormData.account_owner.value,
              form_detail: JSON.stringify(collected_data),
              form_type: "liability",
            },
            api: "save-liability-form-detail",
          })
          .then(() => {
            this.savingAccountList();
            this.$loading(false);
            Toast.fire({
              icon: "success",
              title: "Data added successfully.",
            });
            this.$router
              .push({
                name: "liabilities-dashboard",
                params: {
                  tab: "tab-10",
                },
              })
              .catch(() => {});
          })
          .catch(() => {
            this.$loading(false);
          });
      }
    },

    setMasterData: function (attr_type, val) {
      this.isFormValid = this.$refs.form.validate();
      // if(attr_type == 'emi' && val == '1'){
      //   this.insurance_value = true;
      // }else if (attr_type == 'emi' && val == '0') {
      //   this.other_form_field = [];
      //   this.insurance_value = false;
      //   this.dialog = false;
      // }

      this.isFormValid = this.$refs.form.validate();

    },
    appendFieldOnNominee(attr_type, val) {},
    depositeDashbord() {
      this.$router
        .push({
          name: "liabilities-dashboard",
        })
        .catch(() => {});
    },
    calculateAmounts(attr_type, val) {
      this.isFormValid = this.$refs.form.validate();
      if (attr_type == "no_of_emis" && val <= 5) {
        this.number_of_emi = val;
      } else if (attr_type == "no_of_emis" && val > 5) {
        this.dialog = false;
        swal
          .fire({
            text: "You can add only 5 Credit Card Loans.",
            icon: "warning",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonColor: `#051d42`,
            confirmButtonText: `Ok`,
            cancelButtonColor: `#f19700`,
            denyButtonText: `NO`,
          })
          .then(() => {});
        this.number_of_emi = 0;
        return;
      }
    },
    calculateAmountsWithDates(event, name) {
      if (name == "start_date") {
        this.start_date = event;
      }
      if (name == "expiry_date") {
        this.expiry_date = event;
        this.tenure_left = moment(
          moment(this.expiry_date).format("DD-MM-YYYY"),
          "DD-MM-YYYY"
        ).diff(
          moment(moment(this.currentDate).format("DD-MM-YYYY"), "DD-MM-YYYY"),
          "days"
        );
      }
      if (this.expiry_date < this.currentDate) {
        this.tenure_left = "";
      }
      if (
        this.start_date != "" &&
        this.expiry_date != "" &&
        name != "emi_date"
      ) {
        this.start_date > this.expiry_date
          ? swal
              .fire({
                title: "Expiry Date should be after Start date.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: `#051d42`,
                confirmButtonText: `Ok`,
                cancelButtonColor: `#f19700`,
              })
              .then(() => {})
          : "";
        this.expiry_date < this.start_date
          ? swal
              .fire({
                title: "Expiry Date should be after Start date.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: `#051d42`,
                confirmButtonText: `Ok`,
                cancelButtonColor: `#f19700`,
              })
              .then(() => {})
          : "";
      }
    },
    appendField() {},
    openFormFilelds() {
      if (this.number_of_emi > 0 && this.number_of_emi <= 6) {
        this.$modal.show("formFilelds");
      }
    },
    settingFormData() {
      this.dialog = false;
      if (this.number_of_emi == this.other_form_field.length) {
        swal
          .fire({
            text: "You can not add credit card loan more then number of emis.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: `#051d42`,
            confirmButtonText: `Ok`,
            cancelButtonColor: `#f19700`,
          })
          .then(() => {});

        return;
      }

      if (
        this.number_of_emi <= 5 &&
        this.insurance_value == "1" &&
        this.number_of_emi != 0 &&
        this.number_of_emi >= this.other_form_field.length
      ) {
        let jsonDataFrom = {
          loan_amount: this.loan_amount,
          current_outstanding: this.current_outstanding,
          emi_amount: this.emi_amount,
          emi_start_date: this.emi_start_date,
          emi_end_date: this.emi_end_date,
        };

        this.other_form_field.push(jsonDataFrom);
        this.loan_amount = "";
        this.current_outstanding = "";
        this.emi_amount = "";
        this.this.emi_start_date = null;
        this.emi_end_date = null;
      } else {
        if (this.insurance_value != "1") {
          swal
            .fire({
              text: "Please select a valid insurance policy.",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
            })
            .then(() => {});

          return;
        }

        if (this.number_of_emi == "0") {
          swal
            .fire({
              text: "You can not add Credit Card Loans until you change the value Numbers of EMI",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
            })
            .then(() => {});

          return;
        }

        if (this.number_of_emi == "0") {
          swal
            .fire({
              text: "You can not add Credit Card Loans until you change the value Numbers of EMI",
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: `#051d42`,
              confirmButtonText: `Ok`,
              cancelButtonColor: `#f19700`,
            })
            .then(() => {});

          return;
        }
      }
    },
    getLaibilityFormData() {
      if (this.$store.getters.getUserDetails.user_name != undefined) {
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$store
          .dispatch(GET_CREDIT_CARD_FORM, {
            data: {
              aws_cognito_id: cognito_idp,
              user_name: user_name,
              form_type: 13,
            },
            api: "get-liability-form",
          })
          .then(() => {
            this.form_id = this.$store.getters.getCreditCardForm.data.form_id;
            this.formAttributes =
              this.$store.getters.getCreditCardForm.data.form_attributes.fields;
            let masterDataArr =
              this.$store.getters.getCreditCardForm.data.master_data;

            masterDataArr.forEach((element) => {
              if (element.Bank) {
                element.Bank.forEach((bankName) => {
                  this.bank.push({ id: bankName.id, name: bankName.name });
                });
              }
              if (element.FamilyMember) {
                element.FamilyMember.forEach((dataFamily) => {
                  this.nominee.push(dataFamily.name);
                  if (dataFamily.id == 0) {
                    this.account_owner.push({ id: "0", name: dataFamily.name });
                  } else {
                    this.account_owner.push({
                      id: dataFamily.id,
                      name: dataFamily.name,
                    });
                  }
                });
              }
              if (element.InsuranceType) {
                element.InsuranceType.forEach((insurance) => {
                  if (insurance.id == 0) {
                    this.insurance.push({ id: "0", name: insurance.name });
                  } else {
                    this.insurance.push({
                      id: insurance.id,
                      name: insurance.name,
                    });
                  }
                });
              }
              if (element.EMIDate) {
                element.EMIDate.forEach((emidate) => {
                  if (emidate.id == 0) {
                    this.emi_day.push({ id: "0", name: emidate.name });
                  } else {
                    this.emi_day.push({ id: emidate.id, name: emidate.name });
                  }
                });
              }
              if (element.EMIType) {
                element.EMIType.forEach((emiType) => {
                  this.emi.push({
                    id: emiType.id,
                    name: emiType.name,
                  });
                });
              }
            });
            this.$loading(false);
          })
          .catch(function (error) {});
      }
    },
    savingAccountList() {
      this.$loading(true);
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      let selected_value = this.$store.getters.getUserDetails.selected_value;

      this.$store
        .dispatch(GET_LIABILITY_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id: selected_value,
          },
          api: "get-liability-form-detail",
        })
        .then(() => {
          Fire.$emit("updateLiabilityData");
          this.$loading(false);
        })
        .catch(() => {
          this.$loading(false);
        });
    },
  },
};
</script>